var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.59958 6.54375C7.53708 6.5375 7.46208 6.5375 7.39333 6.54375C5.90586 6.49375 4.72461 5.275 4.72461 3.775C4.72461 2.24375 5.96211 1 7.49958 1C9.03083 1 10.2746 2.24375 10.2746 3.775C10.2683 5.275 9.08708 6.49375 7.59958 6.54375Z",
    stroke: "#5E75B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.47617 8.85C2.96367 9.8625 2.96367 11.5125 4.47617 12.5187C6.19492 13.6687 9.01367 13.6687 10.7324 12.5187C12.2449 11.5062 12.2449 9.85625 10.7324 8.85C9.01992 7.70625 6.20117 7.70625 4.47617 8.85Z",
    stroke: "#3E0292",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileUser);
export default __webpack_public_path__ + "static/media/profileUser.f51eaee82280f14676e4a65641c1915b.svg";
export { ForwardRef as ReactComponent };